module.exports = __webpack_public_path__ + "media/images/pc/croud-single-b0d913bc2d869a260bebcb098377a093.png";